<div id="exportPlaceNamesContainer">

  <div mat-dialog-title class="flex flex-row">
    <div id="titleIconContainer" class="flex flex-row justify-center items-center">
      <mat-icon svgIcon="spellcheck"></mat-icon>
    </div>
    <div id="titleTextContainer" class="flex flex-col justify-center items-center">
      <h1>Export Place Names</h1>
    </div>
  </div>

  <mat-dialog-content class="flex flex-col">

    <div id="locationSelectionContainer">
      <p class="label">Locations</p>
      <mat-radio-group [(ngModel)]="chosenLocations">
        <mat-radio-button [value]="selectedLocationsRadioButton.ALL">
          <span class="cursor-pointer">All locations</span>
        </mat-radio-button>
        <mat-radio-button [value]="selectedLocationsRadioButton.FILTERED"
                          [disabled]="!data.areLocationsFiltered">
          <span class="cursor-pointer">Filtered locations</span>
        </mat-radio-button>
        <mat-radio-button [value]="selectedLocationsRadioButton.SELECTED"
                          [disabled]="!data.areLocationsSelected">
          <span class="cursor-pointer">Selected locations</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div id="languageSelectionContainer">

      <p class="label">Select the place names languages you want to export</p>

      <mat-form-field appearance="fill" class="language-chip-form">
        <mat-chip-grid #chipList aria-label="Language selection">
          @for (language of selectedLanguages; track language) {
            <mat-chip-row (removed)="removeLanguage(language)">
              {{ language.name }}
              <mat-icon matChipRemove svgIcon="cancel"/>
            </mat-chip-row>
          }
        </mat-chip-grid>

        <input appGxInput
               placeholder="Search languages"
               #languageInput
               [formControl]="languageCtrl"
               [matAutocomplete]="auto"
               [matChipInputFor]="chipList"
               [matChipInputSeparatorKeyCodes]="separatorKeysCodes" tabindex="-1">

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectLanguage($event)"
                          class="language-auto-complete-panel">
          @for (language of filteredLanguages | ngrxPush; track language) {
            <mat-option class="language-auto-options"
                        [value]="language">
              {{ language }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="justify-end">
    <button matButton="outlined"
            id="cancelButton"
            mat-dialog-close
            tabindex="-1"
            [mat-dialog-close]="null">{{ 'CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary"
            id="exportButton"
            mat-dialog-close
            tabindex="-1"
            [mat-dialog-close]="generateResult()" [disabled]="noLanguageSelected()">Export
    </button>
  </mat-dialog-actions>

</div>
